import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { emailsAPI } from "api/Interactions/EmailsAPI";
import { Email } from "api/Interactions/InteractionsInterfaces";
import EmailEmptyPage from "./EmailsEmptyPage";
import GenericDetailPage from "components/Interactions/GenericDetailPage";

interface EmailDetailProps {
  emailId: number;
  onClose?: () => void;
}

const EmailDetail: React.FC<EmailDetailProps> = ({ emailId, onClose }) => {
  const theme = useTheme();
  const [record, setRecord] = useState<Email | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const numberOfEmails = (record as any)?.people?.length || 0;
  const costPerEmail = 0.05;

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const data = await emailsAPI.getById(emailId);
        setRecord(data as Email);
      } catch (err) {
        console.error("Error loading email:", err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [emailId]);

  const handleUpdate = async (id: number, field: keyof Email, value: any) => {
    if (typeof id !== "number") return;
    try {
      setSaving(true);
      // ensure we pass a string field name to the API helper
      const updated = await emailsAPI.updateField(id, String(field), value);
      setRecord(updated as Email);
    } catch (err) {
      console.error(`Error updating field "${String(field)}":`, err);
    } finally {
      setSaving(false);
    }
  };

  const handleToggleFulfilled = async () => {
    if (!record) return;
    await handleUpdate(
      record.id,
      "pathways_fulfilled" as keyof Email,
      !(record as any).pathways_fulfilled
    );
  };

  if (loading) return null;
  if (!record) return <EmailEmptyPage />;

  return (
    <GenericDetailPage
      record={record}
      loading={loading}
      saving={saving}
      onClose={onClose}
      onUpdate={handleUpdate}
      onToggleFulfilled={handleToggleFulfilled}
      fulfilled={!!(record as any).pathways_fulfilled}
      fulfillmentDetailsLabel="Emails"
      numberOfItems={numberOfEmails}
      costPerItem={costPerEmail}
      showSaveButton
      saveButtonColor={theme.custom.modules.interactions.primary.dark}
      fulfilledByPathwaysAvailable={false}
      registration={false}
      contentDetailFields={[
        {
          label: "Attachment",
          value: (record as any).attachments ?? null,
          field: "attachments",
          type: "file",
          accept: "*/*,.pdf,image/*",
        },
        {
          label: "Subject",
          value: (record as any).subject,
          field: "subject",
        },
        {
          label: "Message",
          value: (record as any).message,
          field: "message",
          multiline: true,
          rows: 6,
        },
        
      ]}
    />
  );
};

export default EmailDetail;
